import { Box, Label, TextInput } from '@primer/react';
import { useEffect, useMemo, useState } from 'react';
import { baoCaoDiemNenNepApi } from '../../api/baoCaoDiemNenNepApi';
import { ComboboxThang } from '../../components/combobox-thang';
import Button from '../../components/ui/button';
import DataGrid from '../../components/ui/data-grid';
import { NotifyHelper } from '../../helpers/toast';
import { useCommonSelectedHook } from '../../hooks/useCommonSelectedHook';
import { useWindowSize } from '../../hooks/useWindowSize';
import Page from '../../components/ui/page';

export interface IBaoCaoDiemNenNepFilter {
    nam: number,
    thang: number,
    nam_hoc: string,
    dm_truong_id: number
}
const BaoCaoDiemNenNepPage = () => {
    const [dataSource, setDataSource] = useState<any[]>([]);
    const { nam_hoc, dm_truong_id } = useCommonSelectedHook();
    const [filter, setFilter] = useState<IBaoCaoDiemNenNepFilter>({
        nam: new Date().getFullYear(),
        thang: new Date().getMonth() + 1,
        dm_truong_id: dm_truong_id,
        nam_hoc: nam_hoc
    });
    useEffect(() => {
        setFilter(prev => {
            if (prev.dm_truong_id !== dm_truong_id || prev.nam_hoc !== nam_hoc)
                return {
                    ...prev,
                    nam_hoc,
                    dm_truong_id
                }
            return prev;
        })
    }, [nam_hoc, dm_truong_id])
    const { height } = useWindowSize();
    useEffect(() => {
        if (filter.nam && filter.thang && filter.nam_hoc && filter.dm_truong_id > 0) {
            handleReloadAsync();
        }
    }, [filter])
    const handleReloadAsync = async () => {
        const res = await baoCaoDiemNenNepApi.SelectTheoThangAsync(filter)
        if (res.is_success) {
            setDataSource(res.data);
        } else {
            NotifyHelper.Error(res.message ?? "Error")
        }
    }
  
    return (
        <Page>
            <DataGrid
                dataSource={dataSource}
                title="Điền nền nếp"
                exportConfig={{
                    enable: true,
                    fileName: "bao-cao-diem-danh-theo-ngay"
                }}
                actionComponent={
                    <Box sx={{ display: "flex", gap: 1 }}>
                        <TextInput
                            type='number'
                            size='small'
                            width={120}
                            leadingVisual={"Năm"}
                            value={filter.nam}
                            onChange={(e) => {
                                setFilter(prev => {
                                    return {
                                        ...prev,
                                        nam: parseInt(e.target.value)
                                    }
                                })
                            }}
                        />
                        <ComboboxThang
                            value={filter.thang}
                            onValueChanged={(id) => {
                                setFilter(prev => {
                                    return {
                                        ...prev,
                                        thang: id
                                    }
                                })
                            }}
                        />
                    </Box>
                }
                height={height - 140}
                columns={[
                    { dataField: "ten_lop", caption: "Tên lớp", isMainColumn: true, width: 150, fixed: "left" },
                    { dataField: "ho_ten", caption: "Họ tên", width: 200 },

                    { dataField: "tong_so_luong_nhap", caption: "Số lượng\nđã nhập", width: 120, align: "right" },
                    { dataField: "so_ngay_nhap", caption: "Số ngày\nđã nhập", width: 150, align: "right" },
                    { dataField: "tong_so_ngay_lam_viec", caption: "Số ngày\nlàm việc", width: 150, align: "right" },
                    {
                        dataField: "consistency", caption: "% ngày nhập", width: 120, align: "right",
                        cellRender: (data: any) => {
                            return (
                                <Box>
                                    {data.consistency} %
                                </Box>
                            )
                        }
                    },
                    { dataField: "si_so", caption: "Sĩ số", width: 100, align: "right" },
                    { dataField: "so_hs_duoc_nhap", caption: "Số HS\nđược nhập", width: 140, align: "right" },
                    { dataField: "coverage", caption: "% học sinh nhập", width: 150, align: "right" },
                    { dataField: "avg", caption: "Điểm TB", width: 120, align: "right" },
                    { dataField: "noi_dung_max", caption: "Nội dung chủ đạo", width: 200,  isTextWithEllipseLine: true },


                ]}
            />
        </Page>
    );
};

export default BaoCaoDiemNenNepPage;